import { createSelector } from 'reselect';

import { campusSelector } from '../../../reducers/selectors';

const blockedCampusSelector = createSelector(
  campusSelector,

  campus => {
    let isCampusBlocked = false;
    if (campus && campus.blockedReasons.length > 0) {
      isCampusBlocked = true;
    }
    return isCampusBlocked;
  },
);

export default blockedCampusSelector;
